import { observable } from 'mobx';
// import useMount from '@src/utils/hooks/use-mount';
import BaseModalStore from '@src/components/modal-container/base-modal-store';

class PreviewQrcodeModalStore extends BaseModalStore {
  @observable qrcodeImg = '';
  /** 标题类型 weixin custom_service */
  @observable type;
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /** 关闭弹窗 */
  onModalClose = () => {
    this.onClickClose();
    this.onClose();
  };

  // getQrcode = () => {
  //   this.$ztService.getQrCode().then(res => {
  //     this.qrcodeImg = res?.img || '';
  //   });
  // };

  use(onClose) {
    super.use();
    if (onClose) {
      this.onClose = onClose;
    }
    // useMount(() => this.getQrcode());
  }
}

export default PreviewQrcodeModalStore;
